<template>
  <v-container fluid>
    <p>REDIRECTING...</p>
    <v-dialog v-model="dialog" @keydown.enter="changeCompany($route.query.company)" @keydown.esc="closeDialog" persistent max-width="300" scrollable>
      <v-card>
        <v-card-text justify-center>
          <p class="text-md-center">Para continuar é necessário trocar de empresa.</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mx-0" flat color="primary" @click.native="changeCompany()" :loading="confirmLoading">Confirmar</v-btn>
          <v-btn class="mx-0" flat @click.native="closeDialog">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
/* eslint-disable */
// ESLINT desabilitado para ser possível a verificação somente por valor em -> (parseInt(this.company) != this.$auth.user().company_id)
  export default {
    data () {
      return {
        confirmLoading: false,
        dialog: false,
        name: '',
        id: '',
        company: ''
      }
    },
    created () {
      var values = atob(this.$route.params.data).split('|')
      this.name = values[0]
      this.id = values[1]
      this.company = values[2]
      this.$store.commit('loader/change_dialog', true)
      // Se a empresa logada for diferente da empresa que veio na notificação, pergunta ao usuário se ele quer trocar de empresa.
      if (Number.isInteger(parseInt(this.company)) && (parseInt(this.company) != this.$auth.user().company_id)) {
        this.$http.get(`api/has_user_company/${parseInt(this.company)}`).then(res => {
          this.$store.commit('loader/change_dialog', false)
          if (parseInt(res.body) == 1) {
            this.dialog = true
          } else {
            this.$store.commit('snackbar/change_values', {
              text: 'Não foi possível redirecionar.', color: 'warning', dialog: true, timeout: 5000
            })
            this.$router.push(`/home`)
          }
        })
      } else {
        // Se não, somente redireciona ele para a tela da notificação.
        this.$store.commit('loader/change_dialog', false)
        this.$router.push(`/${this.name}/${this.id}`)
      }
    },
    methods: {
      // Se o usuário aceitar logar em outra empresa, realizamos a troca, redirecionamos ele para a tela da notification
      // e recarrega a página para atualizar a company.
      changeCompany () {
        this.confirmLoading = true
        this.$http.post('auth/change-company', {'company_id': this.company}).then(res => {
          this.$router.push(`/${this.name}/${this.id}`)
          location.reload()
        })
      },
      closeDialog () {
        // Se ele clicar em não, volta para a home e continua na mesma empresa.
        // Porque não tem como acessar alguma tarefa/equipe de outra empresa se não estiver logado nela.
        this.dialog = false
        this.$router.push(`/home`)
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/NotificationRedirect.vue